import { Typography } from '@mui/material'
import { InsightItem } from 'components/core/insights'
import { getShortString, getTimeAgoString } from 'components/core/time/display'
import { App } from 'pbts/c1/api/app/v1/app'
import { AppUser } from 'pbts/c1/api/app/v1/app_user'
import { InsightType, UsageInsight } from 'pbts/c1/api/task/v1/insights'
import { Timestamp as pbtsTimestamp } from 'pbts/google/protobuf/timestamp'
import React, { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

type UsageLabelProps = {
    usage: UsageInsight
    app?: App
    appUser?: AppUser
}

export const UsageLabel: FC<UsageLabelProps> = ({ usage, app, appUser }) => {
    const intl = useIntl()
    if (!usage.lastUsedAt || !app) {
        return null
    }
    return (
        <Typography>
            <FormattedMessage
                id="components_insights_usage"
                defaultMessage="{app_user} last logged into {app_name} on {date}: <b>{time_ago}</b>"
                values={{
                    b: (chunks) => <b>{chunks}</b>,
                    app_user: appUser?.displayName || intl.formatMessage({ id: 'usage_unknown_app_user', defaultMessage: 'This account' }),
                    app_name: app.displayName,
                    date: getShortString({ d: pbtsTimestamp.toDate(usage.lastUsedAt), variant: 'date_only' }),
                    time_ago: getTimeAgoString(pbtsTimestamp.toDate(usage.lastUsedAt), intl),
                }}
            />
        </Typography>
    )
}

type UsageProps = {
    usage: UsageInsight
    insightType: InsightType
    app?: App
    appUser?: AppUser
}

export const Usage: FC<UsageProps> = ({ usage, insightType, app, appUser }) => {
    if (!usage.lastUsedAt || !app) {
        return null
    }
    return (
        <InsightItem key="user-status" insightType={insightType}>
            <UsageLabel usage={usage} app={app} appUser={appUser} />
        </InsightItem>
    )
}
